import UniversalForm from 'components/UniversalForm';
import styled from 'styled-components';

export const StyledUniversalForm = styled(UniversalForm)`
    width: 100%;
`;
